<template>
  <!-- 终止合同 -->
  <div>
    <h1 class="item-title">{{ $t('components_contract_stop_contract.he_tong_xin_xi') }}</h1>
    <div class="item-title-info">
      <el-row>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_contract.he_tong_lei_xing') }}:</span>
          <span class="value">{{ getDicValue('crm_contract_type', detail.contractType) }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_contract.he_tong_bian_hao') }}:</span>
          <span class="value">{{ detail.contractNo }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_contract.sghth') }}:</span>
          <span class="value">{{ detail.customContractNo }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_contract.jfsqdbgs') }}:</span>
          <span class="value">{{ detail.partyAName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_contract.yi_fang') }}:</span>
          <span class="value">{{ detail.customerName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_contract.shou_hou_gong_si') }}:</span>
          <span class="value">{{ detail.afterServiceName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_stop_contract.xiang_mu_ming_cheng') }}:</span>
          <span class="value">{{ detail.locationName }}</span>
        </el-col>
        <el-col :span="16">
          <span class="label">{{ $t('components_contract_stop_contract.shi_yong_di_dian') }}:</span>
          <span class="value">{{ detail.country || '' }}{{ detail.province || '' }}{{ detail.city || '' }}{{ detail.useAddress }}</span>
        </el-col>
      </el-row>
    </div>
    <h1 class="item-title">{{ $t('components_contract_stop_contract.sbbgxx') }}</h1>
    <el-form ref="form" :model="form" :rules="rules" label-width="auto">
      <el-form-item :label="$t('components_contract_stop_contract.zhong_zhi_ri_qi')" prop="terminateDate">
        <custom-date-picker
          :disabled="model.type === 'watch'"
          style="width: 230px"
          v-model="form.terminateDate"
          align="right"
          type="date"
          value-format="YYYY-MM-DD HH:mm:ss"
          @change="onDateChange()"
          :picker-options="afterTomorrow"
        ></custom-date-picker>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 30px">
      <custom-table ref="customTb1" :expand="true" :column="tableColumn" :data="dataList" @filter="filterChange" @sort="sortChange" :slots="['totalTerm', 'backLocation']">
        <!-- 展开内容 -->
        <template slot="expand" slot-scope="scope">
          <div v-if="form.terminateDate">
            <el-form label-position="top">
              <el-row>
                <el-col :span="5">
                  <el-form-item :label="$t('components_contract_stop_contract.bqysyscy')">
                    <el-input disabled type="number" :min="0" v-model="scope.row.termUseTime" style="width: 90%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item :label="$t('components_contract_stop_contract.sbzlscy')">
                    <el-input disabled type="number" :min="0" v-model="scope.row.rentUseTime" style="width: 90%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item :label="$t('components_contract_stop_contract.shfwscy')">
                    <el-input disabled type="number" :min="0" v-model="scope.row.scStartTime" style="width: 90%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div class="end-contract-info">
              <el-row>
                <el-col :span="5">
                  <ul>
                    <li v-if="scope.row.factory && detail.hqId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_contract.bqzbysje') }}</span>
                      <span class="value">{{ scope.row.factory.receivedRental || '-' }}</span>
                    </li>
                    <li v-if="scope.row.service && detail.afterServiceId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_contract.bqshysje') }}</span>
                      <span class="value">{{ scope.row.service.receivedRental || '-' }}</span>
                    </li>
                    <li v-if="scope.row.agent">
                      <span class="label">{{ $t('components_contract_stop_contract.bqjfdbysje') }}</span>
                      <span class="value">{{ scope.row.agent.receivedRental || '-' }}</span>
                    </li>
                  </ul>
                </el-col>
                <el-col :span="5">
                  <ul>
                    <li v-if="scope.row.factory && detail.hqId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_contract.zong_bu_zu_jin') }}/{{ $t('components_contract_stop_contract.yue') }}</span>
                      <span class="value">{{ scope.row.factory.receivableFormula || '-' }}</span>
                    </li>
                    <li v-if="scope.row.service && detail.afterServiceId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_contract.shou_hou_zu_jin') }}/{{ $t('components_contract_stop_contract.yue') }}</span>
                      <span class="value">{{ scope.row.service.receivableFormula || '-' }}</span>
                    </li>
                    <li v-if="scope.row.agent">
                      <span class="label">{{ $t('components_contract_stop_contract.yi_fang_zu_jin') }}/{{ $t('components_contract_stop_contract.yue') }}</span>
                      <span class="value">{{ scope.row.agent.receivableFormula || '-' }}</span>
                    </li>
                  </ul>
                </el-col>
                <el-col :span="5">
                  <ul>
                    <li v-if="scope.row.factory && detail.hqId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_contract.bqzbyszj') }}</span>
                      <span class="value">{{ scope.row.factory.receivableRental || '-' }}</span>
                    </li>
                    <li v-if="scope.row.service && detail.afterServiceId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_contract.bqshyszj') }}</span>
                      <span class="value">{{ scope.row.service.receivableRental || '-' }}</span>
                    </li>
                    <li v-if="scope.row.agent">
                      <span class="label">{{ $t('components_contract_stop_contract.bqjfyszj') }}</span>
                      <span class="value">{{ scope.row.agent.receivableRental || '-' }}</span>
                    </li>
                  </ul>
                </el-col>
                <el-col :span="4">
                  <ul>
                    <li v-if="scope.row.factory && detail.hqId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_contract.bqzbytje') }}</span>
                      <el-input
                        v-if="model.approve && scope.row.factory.refundAmount !== undefined && isHq"
                        type="number"
                        :disabled="model.showProcess"
                        :min="0"
                        v-model="scope.row.factory.refundAmount"
                        style="width: 60%"
                      ></el-input>
                      <span class="value" v-else>{{ scope.row.factory.refundAmount || '-' }}</span>
                    </li>
                    <li v-if="scope.row.service && detail.afterServiceId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_contract.bqshytje') }}</span>
                      <el-input
                        v-if="model.approve && scope.row.service.refundAmount !== undefined && isHq"
                        type="number"
                        :disabled="model.showProcess"
                        :min="0"
                        v-model="scope.row.service.refundAmount"
                        style="width: 60%"
                      ></el-input>
                      <span class="value" v-else>{{ scope.row.service.refundAmount || '-' }}</span>
                    </li>
                    <li v-if="scope.row.agent">
                      <span class="label">{{ $t('components_contract_stop_contract.bqjfytje') }}</span>
                      <el-input
                        v-if="(!isHq || detail.hqId === detail.partyAId) && scope.row.agent.refundAmount !== undefined"
                        type="number"
                        :disabled="model.showProcess"
                        :min="0"
                        v-model="scope.row.agent.refundAmount"
                        style="width: 60%"
                      ></el-input>
                      <span class="value" v-else>{{ scope.row.agent.refundAmount || '-' }}</span>
                    </li>
                  </ul>
                </el-col>
                <el-col :span="5">
                  <ul>
                    <li v-if="scope.row.factory && detail.hqId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_contract.zbyswyj') }}</span>
                      <el-input
                        v-if="model.approve && scope.row.factory.receivableBreak !== undefined && isHq"
                        type="number"
                        :min="0"
                        v-model="scope.row.factory.receivableBreak"
                        style="width: 60%"
                      ></el-input>
                      <span class="value" v-else>{{ scope.row.factory.receivableBreak || '-' }}</span>
                    </li>
                    <li v-if="scope.row.service && detail.afterServiceId !== detail.partyAId">
                      <span class="label">{{ $t('components_contract_stop_contract.shyswyj') }}</span>
                      <el-input
                        v-if="model.approve && scope.row.service.receivableBreak !== undefined && isHq"
                        type="number"
                        :min="0"
                        v-model="scope.row.service.receivableBreak"
                        style="width: 60%"
                      ></el-input>
                        <span class="value" v-else>{{ scope.row.service.receivableBreak || '-' }}</span>
                    </li>
                    <li v-if="scope.row.agent">
                      <span class="label">{{ $t('components_contract_stop_contract.jfdbyswyj') }}</span>
                      <el-input
                        v-if="(!isHq || detail.hqId === detail.partyAId) && scope.row.agent.receivableBreak !== undefined"
                        type="number"
                        :disabled="model.type === 'watch'"
                        :min="0"
                        v-model="scope.row.agent.receivableBreak"
                        style="width: 60%"
                      ></el-input>
                      <span class="value" v-else>{{ scope.row.agent.receivableBreak || '-' }}</span>
                    </li>
                  </ul>
                </el-col>
              </el-row>
            </div>
          </div>
          <div v-else style="text-align: center">
            {{ $t('Common.com_no_data') }}
          </div>
        </template>
        <template slot="totalTerm" slot-scope="scope">
          <div v-if="scope.row.termNum && scope.row.totalTerm">{{ scope.row.termNum }}/{{ scope.row.totalTerm }}</div>
        </template>
        <!-- 退回地点 -->
        <template slot="backLocation" slot-scope="scope">
          <custom-select
            width="96%"
            :data="orgList"
            :auto="scope.$index === 0"
            :disabled="model.type === 'watch'"
            v-model="scope.row.deviceBackOrgId"
            url="PartnerHqSc"
            :params="{ orderDeviceId: scope.row.orderDeviceId }"
            :placeholder="scope.$index === 0 ? $t('Common.com_please_select') : $t('components_contract_stop_contract.mo_ren_tong_shang')"
            :props="{ label: 'partnerName', value: 'partnerOrgId' }"
            @change="onSelectBackOrg($event, scope.row)"
            @getList="getList"
          ></custom-select>
        </template>
      </custom-table>
    </div>
    <el-form ref="form1" :model="form" :rules="rules" label-width="auto">
      <el-form-item :label="$t('components_contract_stop_contract.zhong_zhi_yuan_yin')" prop="terminateReason">
        <custom-auto :disabled="model.type === 'watch'" v-model="form.terminateReason" width="230px" value-key="name" code="crm_contract_end_reason"></custom-auto>
      </el-form-item>
      <el-form-item :label="$t('components_contract_stop_contract.shen_qing_miao_shu')" prop="changeDesc">
        <el-input :disabled="model.type === 'watch'" type="textarea" :rows="3" v-model="form.changeDesc" style="width: 626px"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import customAuto from '@/components/customAuto';

export default {
  components: { customAuto },
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add / edit / watch
          changeId: '' // 新增时为orderId, 编辑查看时为changeId
        };
      }
    }
  },
  data() {
    return {
      tableCode: 'contractEndContract',
      dataList: [],
      detail: {},
      orgList: [],
      receivableBreak: '', // 甲方违约金
      form: {
        changeOrderId: '',
        orderId: '',
        terminateDate: '',
        terminateReason: '',
        changeOrderDevices: [],
        changeDesc: ''
      },
      deviceStatus: {}
    };
  },
  computed: {
    rules() {
      return {
        terminateDate: { required: true, message: this.$t('components_contract_stop_contract.qtxzzrq') },
        changeDesc: [{ required: true, message: this.$t('components_contract_stop_contract.qtxsqms') }, { max: 200, message: this.$t('Common.com_rules_length_max', [200]), }],
        terminateReason: [{ required: true, message: this.$t('components_contract_stop_contract.qtxzzyy') }, { max: 20, message: this.$t('Common.com_rules_length_max', [20]), }]
      };
    },
    // 是否总部
    isHq() {
      const userInfo = this.$store.state.userInfo || {};
      return userInfo.bizType === 'HQ';
    }
  },
  mounted() {
    this.getTableColumn();
    this.initDialog();
    this.getDictionary('order_device_biz_state,crm_device_back_type', (data) => {
      this.deviceStatus = this.$transformDicValue(data.order_device_biz_state);
    });
  },
  methods: {
    // 组织下拉
    getList: function (list) {
      this.orgList = list;
    },
    // 处理数据
    formatData: function (to, form) {
      to.breakType = form.breakType;
      to.orderSharingId = form.orderSharingId;
      to.rentUseTime = form.rentUseTime;
      to.scStartTime = form.scStartTime;
      to.termUseTime = form.termUseTime;
      // 自定义字段
      const breakFeeList = form.breakFeeList || [];
      const factory = breakFeeList.find(t => t.receivableOrgType === 'HQ') || {}; // 总部
      const service = breakFeeList.find(t => t.receivableOrgType === 'SC') || {}; // 售后公司
      let agent = breakFeeList.find(t => t.receivableOrgType === 'JV' || t.receivableOrgType === 'JV_SC') || {}; // 代理

      // 甲方代表和总部一致， 保留甲方代表（数据取总部的）
      if (this.detail.partyAId === this.detail.hqId) {
        agent = factory;
      }

      factory.receivableBreak = factory.receivableBreak || '';
      service.receivableBreak = service.receivableBreak || '';
      // agent.receivableBreak = this.model.approve ? this.receivableBreak : agent.receivableBreak || '';
      agent.receivableBreak = agent.receivableBreak || '';
      agent.refundAmount = agent.refundAmount || '';

      to.breakFeeList = form.breakFeeList || [];
      to.agentBreakFee = form.agentBreakFee || '';
      to.factory = factory;
      to.service = service;
      to.agent = agent;

      // to.breakFeeList = form.breakFeeList || [];
      // to.factory = to.breakFeeList.find(t => t.receivableOrgType === 'HQ') || { receivableBreak: '' }; // 总部
      // to.service = to.breakFeeList.find(t => t.receivableOrgType === 'SC') || { receivableBreak: '' }; // 售后公司
      // to.agent = to.breakFeeList.find(t => t.receivableOrgType === 'JV' || t.receivableOrgType === 'JV_SC') || { receivableBreak: '' }; // 代理
      // // 表单字段(和终止设备一样？)
      // this.$set(to, 'agentBreakFee', form.agentBreakFee || '');
      // this.$set(to.factory, 'receivableBreak', to.factory.receivableBreak || '');
      // this.$set(to.service, 'receivableBreak', to.service.receivableBreak || '');
      // this.$set(to.agent, 'receivableBreak', to.agent.receivableBreak || '');
      // to.agentBreakFee = form.agentBreakFee || '';
      // to.factory.receivableBreak = to.factory.receivableBreak || '';
      // to.service.receivableBreak = to.service.receivableBreak || '';
      // to.agent.receivableBreak = to.agent.receivableBreak || '';
    },
    //  终止日期变更
    onDateChange: function () {
      this.dataList.forEach((item) => {
        this.expandChange(item);
      });
    },
    // 违约金计算
    expandChange: function (row) {
      if (this.form.terminateDate) {
        this.$getJSON(apis.OrderChangeDevice, {
          orderDeviceId: row.orderDeviceId,
          endRentDate: this.form.terminateDate
          // feeMode: isSet ? row.feeMode : null,
          // breakFee: isSet ? row.breakFee : null
        })
          .then((res) => {
            this.formatData(row, res.data || {});
          })
          .catch(() => {
            this.formatData(row, {});
          });
      } else {
        this.formatData(row, {});
      }
    },
    // 初始化
    initDialog: function () {
      if (this.model.type === 'add') {
        this.form.orderId = this.model.changeId;
        this.getOrderInfo();
        this.getDeviceList();
      }
      if (this.model.type === 'edit') {
        this.form.changeOrderId = this.model.changeId;
        this.getChangeDetail((list) => {
          this.getDeviceList(list);
        });
      }
      if (this.model.type === 'watch') {
        this.form.changeOrderId = this.model.changeId;
        this.getChangeDetail((list) => {
          this.dataList = list;
          this.dataList.forEach((item) => {
            item.isExists = true;
            this.formatData(item, item);
            this.$refs.customTb1.$emit('toggleRowSelection', item, true);
          });
        });
      }
    },
    // 订单信息
    getOrderInfo: function () {
      this.$getJSON(apis.ChangeOrderInfo, {
        orderId: this.model.changeId
      }).then((res) => {
        this.detail = res.data;
      });
    },
    // 获取变更详情
    getChangeDetail: function (cb) {
      cb = cb || function () {};
      this.$getJSON(apis.OrderChangeInfo, {
        changeOrderId: this.model.changeId
      }).then((res) => {
        this.detail = res.data;
        this.form.orderId = res.data.orderId;
        this.form.changeDesc = res.data.changeDesc;
        this.form.terminateDate = res.data.terminateDate;
        this.form.terminateReason = res.data.terminateReason;
        cb(res.data.changeDeviceInfos);
      });
    },
    // 合同设备列表
    getDeviceList: function (selectDevice) {
      this.$getJSON(apis.OrderChangeDeviceList, {
        orderId: this.form.orderId,
        showDeviceType: 0,
        showCurrentPeriod: 1,
        bizState: ['21', '22', '29']
      }).then((res) => {
        const list = res.data;
        list.forEach((item) => {
          item.deviceBackOrgId = '';
          item.deviceBackOrgName = '';
          this.formatData(item, {});
        });
        this.dataList = list;
        this.$nextTick(() => {
          this.onDateChange();
        });
        if (selectDevice) {
          this.dataList.forEach((item) => {
            const row = selectDevice.find(t => t.orderDeviceId === item.orderDeviceId);
            if (row) {
              item.deviceBackOrgId = row.deviceBackOrgId;
              item.deviceBackOrgName = row.deviceBackOrgName;
              this.formatData(item, row);
              this.$refs.customTb1.$emit('toggleRowSelection', item, true);
            }
          });
        }
      });
    },
    // 选择退回地址
    onSelectBackOrg: function (data, row) {
      row.deviceBackOrgName = data.partnerName;
    },
    // 确认保存
    onConfirm: function (approve) {
      if (this.model.type === 'watch') {
        this.$emit('close');
        return;
      }
      this.$refs.form.validate((valid) => {
        this.$refs.form1.validate((valid1) => {
          if (!valid || !valid1) {
            return;
          }
          if (this.dataList[0] && !this.dataList[0].deviceBackOrgId) {
            this.$message.error(this.$t('components_contract_stop_contract.qxzsysbthdd'));
            return;
          }
          this.form.isStartApprove = approve || 0;
          const changeOrderDevices = this.$formatCopyUp(this.dataList, ['deviceBackOrgId', 'deviceBackOrgName']);
          this.form.changeOrderDevices = changeOrderDevices;
          this.$postJSON(apis.StopContractSave, this.form).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success'
            });
            this.$emit('success');
          });
        });
      });
    }
  }
};
</script>

<style lang="scss">
.end-contract-info {
  border: 1px solid #eee;
  border-radius: 2px;
  padding: 8px 12px;
  ul li {
    margin-bottom: 10px;
    .label {
      color: #495057;
      font-size: 12px;
      line-height: 24px;
      margin-right: 6px;
      font-weight: 500;
      display: block;
    }
    .value {
      display: block;
      color: #6c757d;
      font-size: 12px;
      line-height: 22px;
      text-indent: 2px;
    }
  }
}
</style>
